import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { format } from 'date-fns';
import { setIsPopupDisplayed } from '@store/actions/commonAction';
import {
  HomeMainChannelPopup,
  HomeMainUserEntitlePopup,
  HomeMainNoticePopup,
} from '@container/home';

const stateSelector = state => state.userReducer;

// Device를 tablet으로 고정 (PC 사용안함)
const DEVICE_TYPE = 'tablet';
// const DEVICE_TYPE = $utils.isTablet ? 'tablet' : 'pc';

const POPUP_ORDER_INFO = {
  pc: ['channel'],
  tablet: ['channel', 'entitle', 'notice'],
  mobile: ['channel', 'entitle', 'notice'],
};

const POPUP_SAVE_KEY = {
  channel: 'savedChannel',
  entitle: 'hideEntitlePopup',
  notice: 'hideNoticePopup',
};

const HomeMainPopupController = () => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector(stateSelector);
  const userKey = userInfo?.userId;

  const [popupIndex, setPopupIndex] = useState(0);
  const [popupType, setPopupType] = useState('');

  /* Local Storage에 저장된 팝업 오픈 여부를 확인하는 함수 */
  const checkStopDisplay = popupKey => {
    const today = format(new Date(), 'MM/dd');
    let popups = '';
    try {
      popups = JSON.parse(localStorage.getItem(popupKey) || '[]');
    } catch (e) {
      localStorage.setItem(popupKey, '');
      popups = [];
      console.log('home error => ' + e);
    }

    const isStopDisplay = popups.some(
      popup => popup.userKey === userKey && popup.today === today,
    );

    return isStopDisplay;
  };

  /* 오늘 그만 보기 클릭 시, 내용 저장하는 함수 */
  const onStopDisplay = (popupKey, isStopDisplay) => {
    const today = format(new Date(), 'MM/dd');
    const popupStops = JSON.parse(localStorage.getItem(popupKey) || '[]');

    // 기존에 해당 유저 스토리지 이력 obj
    const userPopupStopInfo = popupStops.find(
      popup => popup.userKey === userKey,
    );

    // 기존에 존재할때는 날짜만 변경
    if (isStopDisplay) {
      const newPopupStops = userPopupStopInfo
        ? popupStops.map(popup =>
            popup.userKey === userKey ? { ...popup, today: today } : popup,
          )
        : [...popupStops, { userKey, today }];

      localStorage.setItem(popupKey, JSON.stringify(newPopupStops));
    }

    // 오늘 그만보기 해지
    else {
      const newPopupStops = popupStops.map(popup =>
        popup.userKey === userKey ? { ...popup, today: '' } : popup,
      );
      localStorage.setItem(popupKey, JSON.stringify(newPopupStops));
    }
  };

  const showPopup = type => setPopupType(type);
  const hidePopup = () => setPopupType('');
  const nextPopup = () => setPopupIndex(popupIndex + 1);

  const checkNextPopup = () => {
    const popupType = POPUP_ORDER_INFO[DEVICE_TYPE][popupIndex];
    const popupKey = POPUP_SAVE_KEY[popupType];

    const isNextPopupExist = popupType && popupKey;

    if (!isNextPopupExist) {
      // 로그인 된 경우만 변경 [홈 화면에서, 로그아웃 되면서 다시 세팅 되는 부분 수정]
      const isLoggedIn = userInfo?.isLoggedIn;
      if (isLoggedIn) dispatch(setIsPopupDisplayed(true));
      hidePopup();
      return;
    }

    const isStopDisplay = checkStopDisplay(popupKey);
    if (isStopDisplay) nextPopup();
    else showPopup(popupType);
  };

  useEffect(checkNextPopup, [popupIndex]);

  return (
    <>
      {/* 채널 선택 팝업 */}
      {popupType === 'channel' && (
        <HomeMainChannelPopup
          isOpen
          popupSaveKey={POPUP_SAVE_KEY?.channel}
          onClose={nextPopup}
          onStopDisplay={onStopDisplay}
        />
      )}

      {/* 자격만료 팝업 */}
      {popupType === 'entitle' && (
        <HomeMainUserEntitlePopup
          isOpen
          popupSaveKey={POPUP_SAVE_KEY?.entitle}
          onClose={nextPopup}
          onStopDisplay={onStopDisplay}
        />
      )}

      {/* 공지사항 팝업 */}
      {popupType === 'notice' && (
        <HomeMainNoticePopup
          isOpen
          popupSaveKey={POPUP_SAVE_KEY?.notice}
          onClose={nextPopup}
          onStopDisplay={onStopDisplay}
        />
      )}
    </>
  );
};

export default HomeMainPopupController;
